import React from "react"
import {graphql, useStaticQuery} from "gatsby"
import ReadMoreBtn from "./read-more-btn";
import ShareBtn from "./share-btn";
import CategoriesList from "./categories-list";
import images from "./images";
import RegulatoryAssociatedFields from "./regulatory-associated-fields";

export default function BlogFeaturedRegulatoryUpdateCard(blog) {

    let q = useStaticQuery(graphql`
  query {
  allWordpressWpLicensesAndApprovals { 
    edges {
      node {
        name
        link
        wordpress_id
      }
    }
  }
  }`);

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-8  px-3 pr-md-0">
                    <div className="fsm-one-side-shadow h-100" style={{overflow:'hidden', backgroundColor:blog.color}}>

                        <div className="card border-0 text-white rounded-0" style={{backgroundColor:'transparent',backgroundImage:"url("+blog.img+")", backgroundPosition:'top right', backgroundRepeat:'no-repeat',backgroundSize:'contain'}}>
                            <div className="pt-4 pl-4 pr-4 pb-2">
                                <div style={{backgroundImage:'url('+images.backDotsIconDark+')', backgroundPosition:'15px 15px', backgroundRepeat:'no-repeat',backgroundSize:'120px auto', filter:'brightness(0.5)'}} > </div>

                                <div className="row">
                                    <div className="col pb-3">
                                        <CategoriesList data={{c1:blog.data.node.categories == null? []:blog.data.node.categories.map(e => e.name), c2:blog.data.node.compliance_services, c3:blog.data.node.licenses_and_approvals}}/>
                                    </div>

                                </div>

                                <div className="card-text fsm-theme-small-text  color-white-alpha" dangerouslySetInnerHTML={{ __html: blog.data.node.excerpt}} />

                                <RegulatoryAssociatedFields  valueColor={"color-white"} keyColor={"color-white-alpha"} data={blog.data.node.acf} />

                            </div>

                            <div className="card-footer bg-transparent border-0 pl-4">
                                <ShareBtn post_title={blog.data.node.title} post_url={new URL(blog.data.node.link).pathname} color={'text-white'} />
                            </div>
                        </div>

                    </div>

                </div>
                <div className="col-12 col-md-4  px-3 pl-md-0">
                    <div className="card fsm-one-side-shadow  border-0 h-100 rounded-0">
                        <div className="card-body">
                            <h5 className="card-title fsm-theme-subheading font-bold" dangerouslySetInnerHTML={{__html: blog.data.node.title}} />
                            <br/>
                            <ReadMoreBtn type={'link'} text={"VIEW MORE"} url={new URL(blog.data.node.link).pathname}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
